import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {City} from '@models/city';
import {Observable, of} from 'rxjs';
import {environment} from '~/environments/environment';
import {EMPTY_PRICE, EMPTY_RENT} from '@models/empty';

@Injectable({
    providedIn: 'root'
})
export class CityService {

    constructor(private http: HttpClient) {
    }

    getQuartier(city: City, sector) {
        let quartier = [];
        if (city.mapping_quartier_iris.quartier === null) {
            return quartier;
        }
        city.mapping_quartier_iris.quartier.forEach(q => {
            if (q.GQ_c == sector || city.mapping_quartier_iris.quartier.length == 1) {
                quartier = q.iris;
            }
        });
        return quartier;
    }

    /**
     * Price
     */
    priceFields = {
        'city.prix_commune.A': {lib: 'Appartement', fulllib: 'les appartements à {{city}}', group: 'Général', selection: 'city'},
        'city.prix_commune.M': {lib: 'Maison', fulllib: 'les maisons à {{city}}', group: 'Général', selection: 'city'},
        'city.prix_commune.P': {lib: 'Garage / Parking', fulllib: 'les garage et parkings à {{city}}', group: 'Général', selection: 'city'},
        'city.prix_commune.T': {lib: 'Terrain', fulllib: 'les terrains à {{city}}', group: 'Général', selection: 'city'},
        'city.prix_commune.I': {lib: 'Immeuble', fulllib: 'les appartements à {{city}}', group: 'Général', selection: 'city'},
        'city.prix_commune.B': {lib: 'Appartement & Maison', fulllib: 'les appartement et maisons à {{city}}', group: 'Général', selection: 'city'},

        'city.prix_commune_gq.A': {lib: 'Appartement', fulllib: 'les appartements à {{city}} dans le secteur de {{quartier}}', group: 'Général', selection: 'quartier'},
        'city.prix_commune_gq.M': {lib: 'Maison', fulllib: 'les maisons à {{city}} dans le secteur de {{quartier}}', group: 'Général', selection: 'quartier'},
        'city.prix_commune_gq.P': {lib: 'Garage / Parking', fulllib: 'les garages à {{city}} et parkings dans le secteur de {{quartier}}', group: 'Général', selection: 'quartier'},
        'city.prix_commune_gq.T': {lib: 'Terrain', fulllib: 'les terrains à {{city}} dans le secteur de {{quartier}}', group: 'Général', selection: 'quartier'},
        'city.prix_commune_gq.I': {lib: 'Immeuble', fulllib: 'les appartements à {{city}} dans le secteur de {{quartier}}', group: 'Général', selection: 'quartier'},
        'city.prix_commune_gq.B': {lib: 'Appartement & Maison', fulllib: 'les appartement et maisons à {{city}} dans le secteur de {{quartier}}', group: 'Général', selection: 'quartier'},

        'city.prix_commune_iris.A': {lib: 'Appartement', fulllib: 'les appartements à {{city}} dans le quartier de {{quartier}}', group: 'Général', selection: 'iris'},
        'city.prix_commune_iris.M': {lib: 'Maison', fulllib: 'les maisons à {{city}} dans le quartier de {{quartier}}', group: 'Général', selection: 'iris'},
        'city.prix_commune_iris.P': {lib: 'Garage / Parking', fulllib: 'les garages à {{city}} et parkings dans le quartier de {{quartier}}', group: 'Général', selection: 'iris'},
        'city.prix_commune_iris.T': {lib: 'Terrain', fulllib: 'les terrains à {{city}} dans le quartier de {{quartier}}', group: 'Général', selection: 'iris'},
        'city.prix_commune_iris.I': {lib: 'Immeuble', fulllib: 'les appartements à {{city}} dans le quartier de {{quartier}}', group: 'Général', selection: 'iris'},
        'city.prix_commune_iris.B': {lib: 'Appartement & Maison', fulllib: 'les appartement et maisons à {{city}} dans le quartier de {{quartier}}', group: 'Général', selection: 'iris'},

        'city.prix_commune_nb_piece.M[\'1\']': {lib: 'Maison 1 pièce/studio', fulllib: 'les maison 1 pièce/studio à {{city}}', group: 'Maison', selection: 'city'},
        'city.prix_commune_nb_piece.M[\'2\']': {lib: 'Maison 2 pièces', fulllib: 'les maisons de 2 pièces à {{city}}', group: 'Maison', selection: 'city'},
        'city.prix_commune_nb_piece.M[\'3\']': {lib: 'Maison 3 pièces', fulllib: 'les maisons de 3 pièces à {{city}}', group: 'Maison', selection: 'city'},
        'city.prix_commune_nb_piece.M[\'4\']': {lib: 'Maison 4 pièces', fulllib: 'les maisons de 4 pièces à {{city}}', group: 'Maison', selection: 'city'},
        'city.prix_commune_nb_piece.M[\'5\']': {lib: 'Maison 5 pièces et +', fulllib: 'les maisons de 5 pièces et + à {{city}}', group: 'Maison', selection: 'city'},

        'city.prix_commune_nb_piece_gq.M[\'1\']': {lib: 'Maison 1 pièce/studio', fulllib: 'les maison 1 pièce/studio à {{city}} dans le secteur de {{quartier}}', group: 'Maison', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.M[\'2\']': {lib: 'Maison 2 pièces', fulllib: 'les maisons de 2 pièces à {{city}} dans le secteur de {{quartier}}', group: 'Maison', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.M[\'3\']': {lib: 'Maison 3 pièces', fulllib: 'les maisons de 3 pièces à {{city}} dans le secteur de {{quartier}}', group: 'Maison', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.M[\'4\']': {lib: 'Maison 4 pièces', fulllib: 'les maisons de 4 pièces à {{city}} dans le secteur de {{quartier}}', group: 'Maison', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.M[\'5\']': {lib: 'Maison 5 pièces et +', fulllib: 'les maisons de 5 pièces et + à {{city}} dans le secteur de {{quartier}}', group: 'Maison', selection: 'quartier'},

        'city.prix_commune_nb_piece_iris.M[\'1\']': {lib: 'Maison 1 pièce/studio', fulllib: 'les maison 1 pièce/studio à {{city}} dans le quartier de {{quartier}}', group: 'Maison', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.M[\'2\']': {lib: 'Maison 2 pièces', fulllib: 'les maisons de 2 pièces à {{city}} dans le quartier de {{quartier}}', group: 'Maison', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.M[\'3\']': {lib: 'Maison 3 pièces', fulllib: 'les maisons de 3 pièces à {{city}} dans le quartier de {{quartier}}', group: 'Maison', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.M[\'4\']': {lib: 'Maison 4 pièces', fulllib: 'les maisons de 4 pièces à {{city}} dans le quartier de {{quartier}}', group: 'Maison', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.M[\'5\']': {lib: 'Maison 5 pièces et +', fulllib: 'les maisons de 5 pièces et + à {{city}} dans le quartier de {{quartier}}', group: 'Maison', selection: 'iris'},

        'city.prix_commune_nb_piece.A[\'1\']': {lib: 'Appartement 1 pièce/studio', fulllib: 'les appartement 1 pièce/studio à {{city}}', group: 'Appartement', selection: 'city'},
        'city.prix_commune_nb_piece.A[\'2\']': {lib: 'Appartement 2 pièces', fulllib: 'les appartements de 2 pièces à {{city}}', group: 'Appartement', selection: 'city'},
        'city.prix_commune_nb_piece.A[\'3\']': {lib: 'Appartement 3 pièces', fulllib: 'les appartements de 3 pièces à {{city}}', group: 'Appartement', selection: 'city'},
        'city.prix_commune_nb_piece.A[\'4\']': {lib: 'Appartement 4 pièces', fulllib: 'les appartements de 4 pièces à {{city}}', group: 'Appartement', selection: 'city'},
        'city.prix_commune_nb_piece.A[\'5\']': {lib: 'Appartement 5 pièces et +', fulllib: 'les appartements de 5 pièces et + à {{city}}', group: 'Appartement', selection: 'city'},

        'city.prix_commune_nb_piece_gq.A[\'1\']': {lib: 'Appartement 1 pièce/studio', fulllib: 'les appartement 1 pièce/studio à {{city}} dans le secteur de {{quartier}}', group: 'Appartement', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.A[\'2\']': {lib: 'Appartement 2 pièces', fulllib: 'les appartements de 2 pièces à {{city}} dans le secteur de {{quartier}}', group: 'Appartement', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.A[\'3\']': {lib: 'Appartement 3 pièces', fulllib: 'les appartements de 3 pièces à {{city}} dans le secteur de {{quartier}}', group: 'Appartement', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.A[\'4\']': {lib: 'Appartement 4 pièces', fulllib: 'les appartements de 4 pièces à {{city}} dans le secteur de {{quartier}}', group: 'Appartement', selection: 'quartier'},
        'city.prix_commune_nb_piece_gq.A[\'5\']': {lib: 'Appartement 5 pièces et +', fulllib: 'les appartements de 5 pièces et + à {{city}} dans le secteur de {{quartier}}', group: 'Appartement', selection: 'quartier'},

        'city.prix_commune_nb_piece_iris.A[\'1\']': {lib: 'Appartement 1 pièce/studio', fulllib: 'les appartement 1 pièce/studio à {{city}} dans le quartier de {{quartier}}', group: 'Appartement', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.A[\'2\']': {lib: 'Appartement 2 pièces', fulllib: 'les appartements de 2 pièces à {{city}} dans le quartier de {{quartier}}', group: 'Appartement', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.A[\'3\']': {lib: 'Appartement 3 pièces', fulllib: 'les appartements de 3 pièces à {{city}} dans le quartier de {{quartier}}', group: 'Appartement', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.A[\'4\']': {lib: 'Appartement 4 pièces', fulllib: 'les appartements de 4 pièces à {{city}} dans le quartier de {{quartier}}', group: 'Appartement', selection: 'iris'},
        'city.prix_commune_nb_piece_iris.A[\'5\']': {lib: 'Appartement 5 pièces et +', fulllib: 'les appartements de 5 pièces et + à {{city}} dans le quartier de {{quartier}}', group: 'Appartement', selection: 'iris'},
    };

    getQuartierName(key, city, iris) {
        let lib = '';
        if (key.includes('_gq') && city.mapping_quartier_iris.quartier) {
            city.mapping_quartier_iris.quartier.forEach(q => {
                if (q.GQ_c == iris.substring(0, 7)) {
                    lib = q.GQ_n;
                }
            });
        }

        if (key.includes('_iris') && city.mapping_quartier_iris.quartier) {
            city.mapping_quartier_iris.quartier.forEach(q => {
                q.iris.forEach(i => {
                    if (i.IRIS_c == iris) {
                        lib = i.IRIS_n;
                    }
                });
            });
        }

        return lib;
    }

    getFullLib(key, city, iris) {
        if (!this.priceFields[key]) {
            return '';
        }
        let lib = this.priceFields[key].fulllib;

        lib = lib.replace('{{quartier}}', this.getQuartierName(key, city, iris));
        lib = lib.replace('{{city}}', city.name);

        return lib;
    }

    getPriceChoice(city: City, iris) {
        let secteur = '';
        let quartier = iris;

        if (iris != '') {
            secteur = iris.substring(0, 7);
        }
        if (quartier.length == 7) {
            // Pas de quartier / tous les quartiers
            quartier = '';
        }

        const choice = {};
        let selection = 'city';
        if (quartier != '') {
            selection = 'iris';
        } else if (secteur != '') {
            selection = 'quartier';
        }

        for (const [key, value] of Object.entries(this.priceFields)) {
            if (value.selection == selection) {
                value.lib = value.lib.replace('{{city}}', city.name);
                if (choice[value.group] === undefined) {
                    choice[value.group] = [];
                }
                const v = this.getPriceValue(city, key, iris);
                choice[value.group][key] = v;
            }
        }

        return choice;
    }

    getPriceValue(city, key, iris) {
        let secteur = '';
        let quartier = iris;

        if (iris != '') {
            secteur = iris.substring(0, 7);
        }
        if (quartier.length == 7) {
            // Pas de quartier / tous les quartiers
            quartier = '';
        }

        if (key === 'city.prix_commune.M' && city.prix_commune.M) {
            return city.prix_commune.M;
        } else if (key === 'city.prix_commune.A' && city.prix_commune.A) {
            return city.prix_commune.A;
        } else if (key === 'city.prix_commune.T' && city.prix_commune.T) {
            return city.prix_commune.T;
        } else if (key === 'city.prix_commune.P' && city.prix_commune.P) {
            return city.prix_commune.P;
        } else if (key === 'city.prix_commune.I' && city.prix_commune.A) {
            return city.prix_commune.A;
        } else if (key === 'city.prix_commune.B' && city.prix_commune.B) {
            return city.prix_commune.B;
        } else if (key.indexOf('city.prix_commune_nb_piece.A[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece.A[\''.length, 1);
            if (city.prix_commune_nb_piece.A === null || city.prix_commune_nb_piece.A[p] === undefined) {
                return EMPTY_PRICE;
            }
            return city.prix_commune_nb_piece.A[p];
        } else if (key.indexOf('city.prix_commune_nb_piece.M[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece.M[\''.length, 1);
            if (city.prix_commune_nb_piece.M === null || city.prix_commune_nb_piece.M[p] === undefined) {
                return EMPTY_PRICE;
            }
            return city.prix_commune_nb_piece.M[p];
        }
        // Secteur
        else if (key === 'city.prix_commune_gq.M' && city.prix_commune_gq[secteur] && city.prix_commune_gq[secteur].M) {
            return city.prix_commune_gq[secteur].M;
        } else if (key === 'city.prix_commune_gq.A' && city.prix_commune_gq[secteur] && city.prix_commune_gq[secteur].A) {
            return city.prix_commune_gq[secteur].A;
        } else if (key === 'city.prix_commune_gq.T' && city.prix_commune_gq[secteur] && city.prix_commune_gq[secteur].T) {
            return city.prix_commune_gq[secteur].T;
        } else if (key === 'city.prix_commune_gq.P' && city.prix_commune_gq[secteur] && city.prix_commune_gq[secteur].P) {
            return city.prix_commune_gq[secteur].P;
        } else if (key === 'city.prix_commune_gq.I' && city.prix_commune_gq[secteur] && city.prix_commune_gq[secteur].A) {
            return city.prix_commune_gq[secteur].A;
        } else if (key === 'city.prix_commune_gq.B' && city.prix_commune_gq[secteur] && city.prix_commune_gq[secteur].B) {
            return city.prix_commune_gq[secteur].B;
        } else if (key.indexOf('city.prix_commune_nb_piece_gq.A[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_gq.A[\''.length, 1);
            if (!city.prix_commune_nb_piece_gq[secteur] || !city.prix_commune_nb_piece_gq[secteur].A || !city.prix_commune_nb_piece_gq[secteur].A[p]) {
                return EMPTY_PRICE;
            }
            return city.prix_commune_nb_piece_gq[secteur].A[p];
        } else if (key.indexOf('city.prix_commune_nb_piece_gq.M[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_gq.M[\''.length, 1);
            if (!city.prix_commune_nb_piece_gq[secteur] || !city.prix_commune_nb_piece_gq[secteur].M || !city.prix_commune_nb_piece_gq[secteur].M[p]) {
                return EMPTY_PRICE;
            }
            return city.prix_commune_nb_piece_gq[secteur].M[p];
        }
        // Quartier
        else if (key === 'city.prix_commune_iris.M' && city.prix_commune_iris && city.prix_commune_iris[quartier] && city.prix_commune_iris[quartier].M) {
            return city.prix_commune_iris[quartier].M;
        } else if (key === 'city.prix_commune_iris.A' && city.prix_commune_iris && city.prix_commune_iris[quartier] && city.prix_commune_iris[quartier].A) {
            return city.prix_commune_iris[quartier].A;
        } else if (key === 'city.prix_commune_iris.T' && city.prix_commune_iris && city.prix_commune_iris[quartier] && city.prix_commune_iris[quartier].T) {
            return city.prix_commune_iris[quartier].T;
        } else if (key === 'city.prix_commune_iris.P' && city.prix_commune_iris && city.prix_commune_iris[quartier] && city.prix_commune_iris[quartier].P) {
            return city.prix_commune_iris[quartier].P;
        } else if (key === 'city.prix_commune_iris.I' && city.prix_commune_iris && city.prix_commune_iris[quartier] && city.prix_commune_iris[quartier].A) {
            return city.prix_commune_iris[quartier].A;
        } else if (key === 'city.prix_commune_iris.B' && city.prix_commune_iris && city.prix_commune_iris[quartier] && city.prix_commune_iris[quartier].B) {
            return city.prix_commune_iris[quartier].B;
        } else if (key.indexOf('city.prix_commune_nb_piece_iris.A[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_iris.A[\''.length, 1);
            if (!city.prix_commune_nb_piece_iris || !city.prix_commune_nb_piece_iris[quartier] || !city.prix_commune_nb_piece_iris[quartier].A || !city.prix_commune_nb_piece_iris[quartier].A[p]) {
                return EMPTY_PRICE;
            }
            return city.prix_commune_nb_piece_iris[quartier].A[p];
        } else if (key.indexOf('city.prix_commune_nb_piece_iris.M[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_iris.M[\''.length, 1);
            if (!city.prix_commune_nb_piece_iris || !city.prix_commune_nb_piece_iris[quartier] || !city.prix_commune_nb_piece_iris[quartier].M || !city.prix_commune_nb_piece_iris[quartier].M[p]) {
                return EMPTY_PRICE;
            }
            return city.prix_commune_nb_piece_iris[quartier].M[p];
        }

        return EMPTY_PRICE;
    }

    getFallbackPriceValue(city, key, iris) {

        let secteur = '';
        let quartier = iris;

        if (iris != '') {
            secteur = iris.substring(0, 7);
        }
        if (quartier.length == 7) {
            // Pas de quartier / tous les quartiers
            quartier = '';
        }

        if (quartier == '' && key.includes('_iris')) {
            key = key.replace('_iris', '_gq');
        }

        if (secteur == '' && key.includes('_gq')) {
            key = key.replace('_gq', '');
        }

        // Nombre de piece
        // -> T2 quartier -> Appartement quartier -> T2 Secteur -> Appartement Secteur -> T2 ville -> Appartement ville -> Appartement et maison ville

        let nbPiece = '';

        /*
         * Appartement
         */

        // T2 quartier
        if (key.indexOf('city.prix_commune_nb_piece_iris.A[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_iris.A[\''.length, 1);
            nbPiece = p;
            if (!city.prix_commune_nb_piece_iris || !city.prix_commune_nb_piece_iris[quartier] || !city.prix_commune_nb_piece_iris[quartier].A || !city.prix_commune_nb_piece_iris[quartier].A[p] || city.prix_commune_nb_piece_iris[quartier].A[p].pM == 0) {
                key = 'city.prix_commune_iris.A'; // -> Appartement quartier
            }
        }

        // -> Appartement quartier
        if (key === 'city.prix_commune_iris.A' && (!city.prix_commune_iris || !city.prix_commune_iris[quartier] || !city.prix_commune_iris[quartier].A || city.prix_commune_iris[quartier].A.pM == 0)) {
            if (nbPiece == '') {
                key = 'city.prix_commune_gq.A'; // -> Appartement Secteur
            } else {
                key = 'city.prix_commune_nb_piece_gq.A[\'' + nbPiece + '\']'; // -> T2 Secteur
            }
        }

        // -> T2 Secteur
        if (key.indexOf('city.prix_commune_nb_piece_gq.A[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_gq.A[\''.length, 1);
            nbPiece = p;
            if (!city.prix_commune_nb_piece_gq || !city.prix_commune_nb_piece_gq[secteur] || !city.prix_commune_nb_piece_gq[secteur].A || !city.prix_commune_nb_piece_gq[secteur].A[p] || city.prix_commune_nb_piece_gq[secteur].A[p].pM == 0) {
                key = 'city.prix_commune_gq.A'; // -> Appartement quartier
            }
        }

        // -> Appartement quartier
        if (key === 'city.prix_commune_gq.A' && (!city.prix_commune_gq || !city.prix_commune_gq[secteur] || !city.prix_commune_gq[secteur].A || city.prix_commune_gq[secteur].A.pM == 0)) {
            if (nbPiece == '') {
                key = 'city.prix_commune.A'; // -> Appartement ville
            } else {
                key = 'city.prix_commune_nb_piece.A[\'' + nbPiece + '\']'; // -> T2 ville
            }
        }

        // -> T2 ville
        if (key.indexOf('city.prix_commune_nb_piece.A[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece.A[\''.length, 1);
            if (!city.prix_commune_nb_piece || !city.prix_commune_nb_piece.A || !city.prix_commune_nb_piece.A[p] || city.prix_commune_nb_piece.A[p].pM == 0) {
                key = 'city.prix_commune.A'; // -> Appartement ville
            }
        }

        if (key === 'city.prix_commune.A' || key === 'city.prix_commune.I') {
            if (!city.prix_commune || !city.prix_commune.A || city.prix_commune.A.pM == 0) {
                key = 'city.prix_commune.B'; // -> Appartement et maison ville
            }
        }

        /*
         * Maison
         */

        if (key.indexOf('city.prix_commune_nb_piece_iris.M[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_iris.M[\''.length, 1);
            nbPiece = p;
            if (!city.prix_commune_nb_piece_iris || !city.prix_commune_nb_piece_iris[quartier] || !city.prix_commune_nb_piece_iris[quartier].M || !city.prix_commune_nb_piece_iris[quartier].M[p] || city.prix_commune_nb_piece_iris[quartier].M[p].pM == 0) {
                key = 'city.prix_commune_iris.M'; // -> Appartement quartier
            }
        }

        // -> Appartement quartier
        if (key === 'city.prix_commune_iris.M' && (!city.prix_commune_iris || !city.prix_commune_iris[quartier] || !city.prix_commune_iris[quartier].M || city.prix_commune_iris[quartier].M.pM == 0)) {
            if (nbPiece == '') {
                key = 'city.prix_commune_gq.M'; // -> Appartement Secteur
            } else {
                key = 'city.prix_commune_nb_piece_gq.M[\'' + nbPiece + '\']'; // -> T2 Secteur
            }
        }

        // -> T2 Secteur
        if (key.indexOf('city.prix_commune_nb_piece_gq.M[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece_gq.M[\''.length, 1);
            nbPiece = p;
            if (!city.prix_commune_nb_piece_gq || !city.prix_commune_nb_piece_gq[secteur] || !city.prix_commune_nb_piece_gq[secteur].M || !city.prix_commune_nb_piece_gq[secteur].M[p] || city.prix_commune_nb_piece_gq[secteur].M[p].pM == 0) {
                key = 'city.prix_commune_gq.M'; // -> Appartement quartier
            }
        }

        // -> Appartement quartier
        if (key === 'city.prix_commune_gq.M' && (!city.prix_commune_gq || !city.prix_commune_gq[secteur] || !city.prix_commune_gq[secteur].M || city.prix_commune_gq[secteur].M.pM == 0)) {
            if (nbPiece == '') {
                key = 'city.prix_commune.M'; // -> Appartement ville
            } else {
                key = 'city.prix_commune_nb_piece.M[\'' + nbPiece + '\']'; // -> T2 ville
            }
        }

        // -> T2 ville
        if (key.indexOf('city.prix_commune_nb_piece.M[\'') === 0) {
            const p = key.substr('city.prix_commune_nb_piece.M[\''.length, 1);
            if (!city.prix_commune_nb_piece || !city.prix_commune_nb_piece.M || !city.prix_commune_nb_piece.M[p] || city.prix_commune_nb_piece.M[p].pM == 0) {
                key = 'city.prix_commune.M'; // -> Appartement ville
            }
        }

        if (key === 'city.prix_commune.M') {
            if (!city.prix_commune || !city.prix_commune.M || city.prix_commune.M.pM == 0) {
                key = 'city.prix_commune.B'; // -> Appartement et maison ville
            }
        }

        return [this.getPriceValue(city, key, iris), key];
    }

    /**
     * Rent
     */
    rentFields = {
        'city.loyer_moyen_petite_ville_cp': {lib: 'Toutes les communes {{city}} - Appartement & Maison', group: 'Général', furnish: 0},
        'city.loyer_moyen_petite_ville': {lib: 'Appartement & Maison', group: 'Général', furnish: 0},
        'city.loyer_moyen_ville.A': {lib: 'Appartement', group: 'Général', furnish: 0},
        'city.loyer_moyen_ville_meuble.A': {lib: 'Appartement meublé', group: 'Général', furnish: 1},
        'city.loyer_moyen_ville_non_meuble.A': {lib: 'Appartement nu', group: 'Général', furnish: 2},
        'city.loyer_moyen_ville.M': {lib: 'Maison', group: 'Général', furnish: 0},
        'city.loyer_moyen_ville_meuble.M': {lib: 'Maison meublé', group: 'Général', furnish: 1},
        'city.loyer_moyen_ville_non_meuble.M': {lib: 'Maison nu', group: 'Général', furnish: 2},
        'city.loyer_moyen_ville.P': {lib: 'Parking/garage', group: 'Général', furnish: 0},
        'city.loyer_moyen_ville_nb_piece[\'1\']': {lib: '1 pièce/studio', group: 'Par pièces', furnish: 0},
        'city.loyer_moyen_ville_nb_piece_meuble[\'1\']': {lib: '1 pièce/studio meublé', group: 'Par pièces', furnish: 1},
        'city.loyer_moyen_ville_nb_piece_non_meuble[\'1\']': {lib: '1 pièce/studio nu', group: 'Par pièces', furnish: 2},
        'city.loyer_moyen_ville_nb_piece[\'2\']': {lib: '2 pièces', group: 'Par pièces', furnish: 0},
        'city.loyer_moyen_ville_nb_piece_meuble[\'2\']': {lib: '2 pièces meublé', group: 'Par pièces', furnish: 1},
        'city.loyer_moyen_ville_nb_piece_non_meuble[\'2\']': {lib: '2 pièces nu', group: 'Par pièces', furnish: 2},
        'city.loyer_moyen_ville_nb_piece[\'3\']': {lib: '3 pièces', group: 'Par pièces', furnish: 0},
        'city.loyer_moyen_ville_nb_piece_meuble[\'3\']': {lib: '3 pièces meublé', group: 'Par pièces', furnish: 1},
        'city.loyer_moyen_ville_nb_piece_non_meuble[\'3\']': {lib: '3 pièces nu', group: 'Par pièces', furnish: 2},
        'city.loyer_moyen_ville_nb_piece[\'4\']': {lib: '4 pièces', group: 'Par pièces', furnish: 0},
        'city.loyer_moyen_ville_nb_piece_meuble[\'4\']': {lib: '4 pièces meublé', group: 'Par pièces', furnish: 1},
        'city.loyer_moyen_ville_nb_piece_non_meuble[\'4\']': {lib: '4 pièces nu', group: 'Par pièces', furnish: 2},
        'city.loyer_moyen_ville_nb_piece[\'5\']': {lib: '5 pièces et plus', group: 'Par pièces', furnish: 0},
        'city.loyer_moyen_ville_nb_piece_meuble[\'5\']': {lib: '5 pièces et plus meublé', group: 'Par pièces', furnish: 1},
        'city.loyer_moyen_ville_nb_piece_non_meuble[\'5\']': {lib: '5 pièces et plus nu', group: 'Par pièces', furnish: 2},
    };

    getFallbackRentValue(city, key) {
        if (key == null) {
            return [EMPTY_RENT, ''];
        }
        if (key.indexOf('city.loyer_moyen_ville_nb_piece_meuble[\'') === 0 || key.indexOf('city.loyer_moyen_ville_nb_piece_non_meuble[\'') === 0) {
            let p = '';
            if (key.indexOf('city.loyer_moyen_ville_nb_piece_meuble[\'') === 0) {
                p = key.substr('city.loyer_moyen_ville_nb_piece_meuble[\''.length, 1);
            }
            if (key.indexOf('city.loyer_moyen_ville_nb_piece_non_meuble[\'') === 0) {
                const p = key.substr('city.loyer_moyen_ville_nb_piece_non_meuble[\''.length, 1);
            }

            if (city.loyer_moyen_ville_nb_piece[p]) {
                return [city.loyer_moyen_ville_nb_piece[p], 'city.loyer_moyen_ville_nb_piece[' + p + ']'];
            }

            if (city.loyer_moyen_ville.A) {
                return [city.loyer_moyen_ville.A, 'city.loyer_moyen_ville.A'];
            }
        } else if (key.indexOf('city.loyer_moyen_ville_nb_piece[\'') === 0) {
            if (city.loyer_moyen_ville.A) {
                return [city.loyer_moyen_ville.A, 'city.loyer_moyen_ville.A'];
            }
        } else if (key == 'city.loyer_moyen_ville_meuble.M' || key == 'city.loyer_moyen_ville_non_meuble.M') {
            if (city.loyer_moyen_ville.M) {
                return [city.loyer_moyen_ville.M, 'city.loyer_moyen_ville.M'];
            }
        } else if (key == 'city.loyer_moyen_ville_meuble.A' || key == 'city.loyer_moyen_ville_non_meuble.A') {
            if (city.loyer_moyen_ville.A) {
                return [city.loyer_moyen_ville.A, 'city.loyer_moyen_ville.A'];
            }
        }

        if (city.loyer_moyen_petite_ville) {
            return [city.loyer_moyen_petite_ville, 'city.loyer_moyen_petite_ville'];
        }
        if (city.loyer_moyen_petite_ville_cp) {
            return [city.loyer_moyen_petite_ville_cp, 'city.loyer_moyen_petite_ville_cp'];
        }

        return [EMPTY_RENT, ''];
    }

    getRentValue(city, key) {
        if (key == null) {
            return EMPTY_RENT;
        }
        if (key === 'city.loyer_moyen_ville.C' && city.loyer_moyen_ville_coloc) {
            return city.loyer_moyen_ville_coloc;
        } else if (key === 'city.loyer_moyen_ville.M' && city.loyer_moyen_ville.M) {
            return city.loyer_moyen_ville.M;
        } else if (key === 'city.loyer_moyen_ville_meuble.M' && city.loyer_moyen_ville_meuble.M) {
            return city.loyer_moyen_ville_meuble.M;
        } else if (key === 'city.loyer_moyen_ville_non_meuble.M' && city.loyer_moyen_ville_non_meuble.M) {
            return city.loyer_moyen_ville_non_meuble.M;
        } else if (key === 'city.loyer_moyen_ville.A' && city.loyer_moyen_ville.A) {
            return city.loyer_moyen_ville.A;
        } else if (key === 'city.loyer_moyen_ville_meuble.A' && city.loyer_moyen_ville_meuble.A) {
            return city.loyer_moyen_ville_meuble.A;
        } else if (key === 'city.loyer_moyen_ville_non_meuble.A' && city.loyer_moyen_ville_non_meuble.A) {
            return city.loyer_moyen_ville_non_meuble.A;
        } else if (key === 'city.loyer_moyen_ville.P' && city.loyer_moyen_ville.P) {
            return city.loyer_moyen_ville.P;
        } else if (key === 'city.loyer_moyen_petite_ville' && city.loyer_moyen_petite_ville) {
            return city.loyer_moyen_petite_ville;
        } else if (key === 'city.loyer_moyen_petite_ville_cp' && city.loyer_moyen_petite_ville_cp) {
            return city.loyer_moyen_petite_ville_cp;
        } else if (city.loyer_moyen_ville_nb_piece && key.indexOf('city.loyer_moyen_ville_nb_piece[\'') === 0) {
            const p = key.substr('city.loyer_moyen_ville_nb_piece[\''.length, 1);
            if (city.loyer_moyen_ville_nb_piece[p]) {
                return city.loyer_moyen_ville_nb_piece[p];
            }
        } else if (city.loyer_moyen_ville_nb_piece_meuble && key.indexOf('city.loyer_moyen_ville_nb_piece_meuble[\'') === 0) {
            const p = key.substr('city.loyer_moyen_ville_nb_piece_meuble[\''.length, 1);
            if (city.loyer_moyen_ville_nb_piece_meuble[p]) {
                return city.loyer_moyen_ville_nb_piece_meuble[p];
            }
        } else if (city.loyer_moyen_ville_nb_piece_non_meuble && key.indexOf('city.loyer_moyen_ville_nb_piece_non_meuble[\'') === 0) {
            const p = key.substr('city.loyer_moyen_ville_nb_piece_non_meuble[\''.length, 1);
            if (city.loyer_moyen_ville_nb_piece_non_meuble[p]) {
                return city.loyer_moyen_ville_nb_piece_non_meuble[p];
            }
        }
        return EMPTY_RENT;
    }


    getRentChoice(city: City, furnish = 0) {
        const choice = {};

        for (const [key, value] of Object.entries(this.rentFields)) {
            if (value.furnish === furnish || value.furnish == -1) {
                value.lib = value.lib.replace('{{city}}', city.name);
                if (choice[value.group] === undefined) {
                    choice[value.group] = [];
                }
                const v = this.getRentValue(city, key);
                choice[value.group][key] = v;
            }
        }

        return choice;
    }

    hasFurnish(city: City, furnish): boolean {
        const choices = this.getRentChoice(city, furnish);
        for (const [k, group] of Object.entries(choices)) {
            for (const [k1, value] of Object.entries(group)) {
                if (value !== undefined && value.x0 !== 0 && this.rentFields[k1].furnish != -1) {
                    return true;
                }
            }
        }
        return false;
    }

    search(name, dep = false): Observable<City[]> {
        if (name === '' || name === null || typeof name === 'object') {
            return of([]);
        }
        $('.citySpinner').show();
        return this.http.get<City[]>(environment.apiUrl + 'app/city/find/' + name + '?dep=' + dep);
    }
}

